import { ReviewFormConfigModel } from './review-dynamic.model';

export class UserModel {
    clientId: string;
    firstName: string;
    lastName: string;
    displayName: string;
    email: string;
    phoneNumber: string;
    isSelected: boolean;
    formProperties: ReviewFormConfigModel[];
    formConfigurations: any;
    licenseClientId ?: string;
}
